import { keyframes } from 'typestyle';
import { CSSProperties } from 'typestyle/lib/types';

export const keyframesPulse = keyframes({
  '0%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0
  }
});

export const animationPulse: CSSProperties = {
  animationName: keyframesPulse,
  animationDirection: 'alternate',
  animationDuration: '1s',
  animationIterationCount: 'infinite'
};

export const keyframesBounce = keyframes({
  '0%': {
    transform: 'translate3d(0, 0, 0)',
  },
  '40%': {
    transform: 'translate3d(0, 0, 0)',
  },
  '60%': {
    transform: 'translate3d(0, -0.25em, 0)',
  },
  '80%': {
    transform: 'translate3d(0, 0, 0)',
  }
});

export const animationBounce: CSSProperties = {
  animationName: keyframesBounce,
  animationDuration: '2s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-in-out',
  animationDirection: 'alternate',
};

export const keyframesSlowPulseOne = keyframes({
  '0%': {
    opacity: 0,
  },
  '40%': {
    opacity: 0,
  },
  '50%': {
    opacity: 1,
  },
  '90%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0,
  }
});

export const keyframesSlowPulseTwo = keyframes({
  '0%': {
    opacity: 1,
  },
  '40%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0,
  },
  '90%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  }
});

export const animationSlowPulseOne: CSSProperties = {
  animationName: keyframesSlowPulseOne,
  animationDuration: '6s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-in-out',
};

export const animationSlowPulseTwo: CSSProperties = {
  animationName: keyframesSlowPulseTwo,
  animationDuration: '6s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-in-out',
};